import { EventsFilter } from '../interfaces';

const saved_searches = 'saved_searches';
const search_presets = 'search_presets';
const cache_size = 10;

export abstract class SavedSearchService {
  private static get = (localStorageKey: string): EventsFilter[] => {
    const saved = window.localStorage.getItem(localStorageKey);

    if (saved === null) {
      return [];
    }

    try {
      const parsed: EventsFilter[] = JSON.parse(saved);
      return parsed;
    } catch (e) {
      return [];
    }
  };

  private static save = (filter: EventsFilter, localStorageKey: string): any => {
    let savedCache = SavedSearchService.get(localStorageKey);

    // Remove all instances of currently triggered search to avoid duplicates
    const currentFilter = JSON.stringify(filter);
    savedCache = savedCache.filter((sc) => JSON.stringify(sc) !== currentFilter);

    savedCache.unshift(filter);
    savedCache = savedCache.slice(0, cache_size);
    window.localStorage.setItem(localStorageKey, JSON.stringify(savedCache));

    return true;
  };

  public static saveSearch = (filter: EventsFilter): boolean => {
    return SavedSearchService.save(filter, saved_searches);
  };

  public static savePreset = (filter: EventsFilter): boolean => {
    return SavedSearchService.save(filter, search_presets);
  };

  public static getPresets = (): EventsFilter[] => {
    return SavedSearchService.get(search_presets);
  };

  public static getRecentSearches = (): EventsFilter[] => {
    return SavedSearchService.get(saved_searches);
  };
}
